import ApiService from "@/core/services/api.service";
import {API_URL} from '@/common/config.js'

const apiService = ApiService;


export default class BookAccessionService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/library/book`;

    }

    searchAccessionNo(id, accessionNo) {
        let url = `${this.#api}/${id}/accession/${accessionNo}/list`
        return apiService.get(url);
    }

    toggleAvailability(id, accessionId) {
        let url = `${this.#api}/${id}/accession/${accessionId}/toggle`
        return apiService.get(url);
    }

    update(id, accessionId, data) {
        let url = `${this.#api}/${id}/update/accession/${accessionId}`
        return apiService.post(url, data);

    }

    store(data) {
        let url = `${this.#api}/${id}/accession`
        return apiService.post(url, data);

    }

    show(id, accessionId) {
        let url = `${this.#api}/${id}/accession/${accessionId}`
        return apiService.get(url);
    }


    delete(id, accessionId) {
        let url = `${this.#api}/${id}/accession/${accessionId}`
        return apiService.delete(url);
    }

    updateAccessions(id, data) {
        let url = `${this.#api}/${id}/accessions/update`
        return apiService.post(url, data);
    }

    getBookAccessions(id) {
        let url = `${this.#api}/${id}/accession`
        return apiService.get(url);
    }

    validateAccession(accessionNo) {
        let url = `${this.#api}/accession/${accessionNo}/validate`
        return apiService.get(url);
    }

    autoGenerateAccessionNo(bookId, data) {
        let url = `${this.#api}/${bookId}/accession/generate-accession`
        return apiService.post(url, data);
    }

    searchByAccessionNo(accession) {
        let url = `${this.#api}/accession/${accession}/search`
        return apiService.get(url);
    }
    markAsLost(id,data){
        let url = `${this.#api}/${id}/mark-as-lost`;
        return apiService.post(url, data);
    }
    getAllLostBooks(data={},index=null){
        let url = `${this.#api}/get/all/lost-books`;
        if (index != null)
            url = `${url}?page=${index}`;
        let param ={
            params: data
        }
        return apiService.query(url,param);
    }


}